import {getServiceEnvironment} from './getServiceEnvironment';

export const getAdminBaseUrl = (): string => {
  const env = getServiceEnvironment();
  const {hostname} = window.location;

  switch (env) {
    case 'prod':
      return 'https://admin.corp.stripe.com';
    case 'preprod':
      return 'https://admin.preprod.corp.stripe.com';
    case 'qa':
    case 'isolated_qa':
      return 'https://admin.qa.corp.stripe.com';
    case 'devbox':
      const match = hostname.match(/^([^-]+(?:-[^-]+)+)--/);
      const devBoxUserName = match ? match[0] : '';
      return `https://${devBoxUserName}admin-mydev.dev.stripe.me`;
    default:
      return 'https://admin.corp.stripe.com';
  }
};
